import React from "react";

export default function Footer() {
  return (
    <div class="container footer-container">
      <p>
        Carter Kwon -&nbsp;
        <a href="mailto:carterkwon@me.com" target="_blank">
          carterkwon@me.com
        </a>
      </p>
    </div>
  );
}
